import React from 'react';
import { Spin } from 'antd';

const antIcon = (<div className='always-default-epinner'>
    <Spin />
    </div>
);

const SpinLoader = () => <Spin indicator={antIcon} />;

export default SpinLoader;
